
/* ==========================================================
   WEAVEPLACE — SEARCH POSITION v1.8
   Shopify Dawn

   Search panel replaces the visible header.

   - At page top: below announcement bar
   - When scrolled: at visible header top
   - Locks position when Search opens
   - Preserves Dawn native Search functionality
   ========================================================== */

(() => {
  'use strict';

  const init = () => {
    const section = document.querySelector('.section-header');

    const search = section?.querySelector(
      '.header__icons > details-modal.wp-header-search'
    );

    const details = search?.querySelector(':scope > details');

    if (!section || !search || !details) return;

    const root = document.documentElement;

    let locked = false;
    let queued = false;

    /*
     * Calculate the actual header position.
     *
     * This automatically accounts for the announcement bar
     * without needing to locate that bar separately.
     */
    const calculateAnchor = () => {
      const rect = section.getBoundingClientRect();

      return Math.round(
        Math.max(
          0,
          Math.min(rect.top, window.innerHeight)
        )
      );
    };

    const setAnchor = (force = false) => {
      if (locked && !force) return;

      root.style.setProperty(
        '--wp-search-anchor-bottom',
        `${calculateAnchor()}px`
      );
    };

    /*
     * Synchronize the Search state with Dawn.
     */
    const update = () => {
      const open = details.hasAttribute('open');

      section.classList.toggle('wp-search-active', open);

      if (!open) {
        locked = false;
        setAnchor(true);
      } else if (!locked) {
        setAnchor(true);
        locked = true;
      }
    };

    /*
     * Capture the header position BEFORE Dawn opens
     * the modal and potentially locks page scrolling.
     */
    const beginOpen = () => {
      if (details.open) return;

      locked = false;
      setAnchor(true);
      locked = true;
    };

    search.addEventListener(
      'pointerdown',
      (event) => {
        if (event.target.closest('.wp-search-trigger')) {
          beginOpen();
        }
      },
      true
    );

    search.addEventListener(
      'keydown',
      (event) => {
        if (
          (event.key === 'Enter' || event.key === ' ') &&
          event.target.closest('.wp-search-trigger')
        ) {
          beginOpen();
        }
      },
      true
    );

    /*
     * Watch the native details element.
     */
    new MutationObserver(update).observe(details, {
      attributes: true,
      attributeFilter: ['open']
    });

    const schedule = () => {
      if (queued) return;

      queued = true;

      requestAnimationFrame(() => {
        queued = false;

        if (!locked) {
          setAnchor();
        }
      });
    };

    window.addEventListener('scroll', schedule, {
      passive: true
    });

    window.addEventListener('resize', schedule, {
      passive: true
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(schedule).observe(section);
    }

    update();
    setAnchor();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})();
